import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';
import './modules/_utils/closest.polyfill';
import ReactHabitat from 'react-habitat';
import Button from './modules/Button/Button';
import AccessibleLinks from './modules/AccessibleLinks/AccessibleLinks';
import SidebarNav from './modules/SidebarNav/SidebarNav';
import BackToTop from './modules/BackToTop/BackToTop';
import Header from './modules/Header/Header';
import SearchBox from './modules/SearchBox/SearchBox';
import LatestNews from './modules/LatestNews/LatestNews';
import Slider from './modules/Slider/Slider';
import FeaturedContent from './modules/FeaturedContent/FeaturedContent';
import VideoPlayer from './modules/VideoPlayer/VideoPlayer';
import FeaturedVideos from './modules/FeaturedVideos/FeaturedVideos';
import SimpleVideos from './modules/SimpleVideos/SimpleVideos';
import DatePicker from './modules/DatePicker/DatePicker';
import Filters from './modules/Filters/Filters';
import SelectBox from './modules/SelectBox/SelectBox';
import Accordion from './modules/Accordion/Accordion';
import TabNav from './modules/TabNav/TabNav';
import FacilityTag from './modules/FacilityTag/FacilityTag';

// CSS
import './styles/global.scss';

class HabitatApp extends ReactHabitat.Bootstrapper {
  constructor() {
    super();

    // Create a new container builder:
    const builder = new ReactHabitat.ContainerBuilder();

    // Register a component:
    builder.register(Button).as('Button');
    builder.register(AccessibleLinks).as('AccessibleLinks');
    builder.register(SidebarNav).as('SidebarNav');
    builder.register(BackToTop).as('BackToTop');
    builder.register(Header).as('Header');
    builder.register(SearchBox).as('SearchBox');
    builder.register(LatestNews).as('LatestNews');
    builder.register(Slider).as('Slider');
    builder.register(FeaturedContent).as('FeaturedContent');
    builder.register(VideoPlayer).as('VideoPlayer');
    builder.register(FeaturedVideos).as('FeaturedVideos');
    builder.register(SimpleVideos).as('SimpleVideos');
    builder.register(DatePicker).as('DatePicker');
    builder.register(Filters).as('Filters');
    builder.register(SelectBox).as('SelectBox');
    builder.register(Accordion).as('Accordion');
    builder.register(TabNav).as('TabNav');
    builder.register(FacilityTag).as('FacilityTag');

    // Or register a component to load on demand asynchronously:
    // builder.registerAsync(() => System.import('./AnotherReactComponent')).as('AnotherReactComponent');

    // Finally, set the container:
    this.setContainer(builder.build());
  }
}

// Always export a 'new' instance so it immediately evokes:
export default new HabitatApp();
